import React from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
import PropTypes from 'prop-types';
import ContactTooltip from '../../common/components/ContactTooltip';

const RequestForChangesTableRow = ({ item }) => {
  return (
    <>
      <td>{item.serial}</td>
      <td>
        <ContactTooltip
          id={`dealer-tooltip${item.id}`}
          label={item?.organization?.tradeName}
          firstName={item?.contactFirstName}
          lastName={item?.contactLastName}
          phoneNumber={item?.contactPhoneNumber}
          landlinePhoneNumber={item?.contactLandlinePhoneNumber}
        />
      </td>
      <td>{item.description}</td>
      <td className="text-right">
        <Button
          className="btn-link"
          color="primary"
          id={`tooltip${item.id}`}
          size="sm"
          type="button"
        >
          <i className="fa fa-edit" />
        </Button>
        <UncontrolledTooltip delay={0} target={`tooltip${item.id}`}>
          View
        </UncontrolledTooltip>
      </td>
    </>
  );
};

RequestForChangesTableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default RequestForChangesTableRow;
